var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAside2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "336.167px",
    height: "858.829px",
    viewBox: "0 0 336.167 858.829",
    enableBackground: "new 0 0 336.167 858.829",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4FAFE",
    d: "M336.167,0c-25.067,4.489-48.943,15.99-68.604,34.755c-26.102,24.914-40.056,57.895-41.82,91.808 c-2.068,26.099-14.511,53.043-36.664,74.188c-18.541,17.697-40.826,28.412-62.941,31.938c-31.33,2.057-61.257,14.105-84.755,36.534 c-57.488,54.871-54.741,151.055,6.134,214.833c20.258,21.225,44.404,36.178,69.721,44.672 c39.456,15.242,80.537,42.711,116.739,80.64c55.134,57.764,85.533,125.708,85.952,180.567l0.012,0.009 c0.691,23.269,6.114,46.751,16.228,68.886V0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAside2);
export default __webpack_public_path__ + "static/media/aside2.3401247b6a7e93522510c1b856350090.svg";
export { ForwardRef as ReactComponent };